// Light theme base text "#3d3d3d"
// primary color "#f7f7f7"
// secondary color: "#ffffff",
// dark color for contrast on background:

export const lightTheme = {
  text: "#1c1c1c",
  primary: "#eaeaea",
  secondary: "#ffffff",
  accentColor: "#eaeaea",
  hover: "#000000",
  label: "rgb(66, 66, 66)",
  overlay: "rgba(225, 225, 225, 0)",
  overlayHover: "rgba(225, 225, 225, 0.7)",
}

export const darkTheme = {
  text: "#ffffff",
  primary: "#151515",
  secondary: "#0f0f0f",
  accentColor: "#151515",
  hover: "#ffffff",
  label: "rgb(134, 134, 134)",
  overlay: "rgba(0, 0, 0, 0)",
  overlayHover: "rgba(0, 0, 0, 0.7)",
}
